import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubSearchRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-search',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId',
};
